<template>
  <div class="c-survey__inner c-survey__bg--blue">
    <div class="c-survey__content c-survey__content--padding">
      <div class="c-survey__remaining-tokens-wrapper c-survey__remaining-tokens-wrapper--mobile">
        <div class="c-survey__remaining-tokens white-text">
          <h1>{{ getRemainingTokens }}</h1>
        </div>
        <div class="c-survey__remaining-tokens-text white-text">total remaining tokens</div>
      </div>

      <main v-html="pageThree.content" class="c-survey__html"></main>

      <div class="c-survey__grid c-survey__grid--page-three">
        <div class="c-survey__grid c-survey__grid--page-three-tokens">
          <div class="c-survey__page-three--spacer"><!-- Empty --></div>
          <div class="c-survey__remaining-tokens-wrapper c-survey__remaining-tokens-wrapper--desktop">
            <div class="c-survey__remaining-tokens white-text">
              <h1>{{ getRemainingTokens }}</h1>
            </div>
            <div class="c-survey__remaining-tokens-text white-text">total remaining tokens</div>
          </div>

          <div class="c-survey__section-summary" :style="{ backgroundColor: sections.sectionOne.sectionColour }">
            <h3 class="white-text">{{ sections.sectionOne.label }}</h3>
            <p class="white-text">{{ sections.sectionOne.shortDescription }}</p>
            <div class="c-survey__token-buttons c-survey__token-buttons--mobile">
              <div
                class="c-survey__token-button"
                :class="{ 'c-survey__token-button--disabled': isRemoveButtonDisabled('sectionOneTokens') }"
                @click="updateTokens('sectionOneTokens', -1)"
                :style="{ backgroundColor: isRemoveButtonDisabled('sectionOneTokens') ? '#bcbec0' : sections.sectionOne.sectionColour }"
              >
                <div class="c-survey__icon c-survey__icon--minus"></div>
              </div>
              <h1 class="c-survey__token-allocation-count white-text">{{ submissionData.sectionOneTokens }}</h1>
              <div
                class="c-survey__token-button"
                @click="updateTokens('sectionOneTokens', 1)"
                :class="{ 'c-survey__token-button--disabled': isAddButtonDisabled }"
                :style="{ backgroundColor: isAddButtonDisabled ? '#bcbec0' : sections.sectionOne.sectionColour }"
              >
                <div class="c-survey__icon c-survey__icon--plus"></div>
              </div>
            </div>
          </div>
          <div class="c-survey__token-buttons c-survey__token-buttons--desktop">
            <div
              class="c-survey__token-button"
              :class="{ 'c-survey__token-button--disabled': isRemoveButtonDisabled('sectionOneTokens') }"
              @click="updateTokens('sectionOneTokens', -1)"
              :style="{ backgroundColor: isRemoveButtonDisabled('sectionOneTokens') ? '#bcbec0' : sections.sectionOne.sectionColour }"
            >
              <div class="c-survey__icon c-survey__icon--minus"></div>
            </div>
            <h1 class="c-survey__token-allocation-count white-text">{{ submissionData.sectionOneTokens }}</h1>
            <div
              class="c-survey__token-button"
              @click="updateTokens('sectionOneTokens', 1)"
              :class="{ 'c-survey__token-button--disabled': isAddButtonDisabled }"
              :style="{ backgroundColor: isAddButtonDisabled ? '#bcbec0' : sections.sectionOne.sectionColour }"
            >
              <div class="c-survey__icon c-survey__icon--plus"></div>
            </div>
          </div>

          <div class="c-survey__section-summary" :style="{ backgroundColor: sections.sectionTwo.sectionColour }">
            <h3 class="white-text">{{ sections.sectionTwo.label }}</h3>
            <p class="white-text">{{ sections.sectionTwo.shortDescription }}</p>
            <div class="c-survey__token-buttons c-survey__token-buttons--mobile">
              <div
                class="c-survey__token-button"
                :class="{ 'c-survey__token-button--disabled': isRemoveButtonDisabled('sectionTwoTokens') }"
                @click="updateTokens('sectionTwoTokens', -1)"
                :style="{ backgroundColor: isRemoveButtonDisabled('sectionTwoTokens') ? '#bcbec0' : sections.sectionTwo.sectionColour }"
              >
                <div class="c-survey__icon c-survey__icon--minus"></div>
              </div>
              <h1 class="c-survey__token-allocation-count white-text">{{ submissionData.sectionTwoTokens }}</h1>
              <div
                class="c-survey__token-button"
                @click="updateTokens('sectionTwoTokens', 1)"
                :class="{ 'c-survey__token-button--disabled': isAddButtonDisabled }"
                :style="{ backgroundColor: isAddButtonDisabled ? '#bcbec0' : sections.sectionTwo.sectionColour }"
              >
                <div class="c-survey__icon c-survey__icon--plus"></div>
              </div>
            </div>
          </div>
          <div class="c-survey__token-buttons c-survey__token-buttons--desktop">
            <div
              class="c-survey__token-button"
              :class="{ 'c-survey__token-button--disabled': isRemoveButtonDisabled('sectionTwoTokens') }"
              @click="updateTokens('sectionTwoTokens', -1)"
              :style="{ backgroundColor: isRemoveButtonDisabled('sectionTwoTokens') ? '#bcbec0' : sections.sectionTwo.sectionColour }"
            >
              <div class="c-survey__icon c-survey__icon--minus"></div>
            </div>
            <h1 class="c-survey__token-allocation-count white-text">{{ submissionData.sectionTwoTokens }}</h1>
            <div
              class="c-survey__token-button"
              @click="updateTokens('sectionTwoTokens', 1)"
              :class="{ 'c-survey__token-button--disabled': isAddButtonDisabled }"
              :style="{ backgroundColor: isAddButtonDisabled ? '#bcbec0' : sections.sectionTwo.sectionColour }"
            >
              <div class="c-survey__icon c-survey__icon--plus"></div>
            </div>
          </div>

          <div class="c-survey__section-summary" :style="{ backgroundColor: sections.sectionThree.sectionColour }">
            <h3 class="white-text">{{ sections.sectionThree.label }}</h3>
            <p class="white-text">{{ sections.sectionThree.shortDescription }}</p>
            <div class="c-survey__token-buttons c-survey__token-buttons--mobile">
              <div
                class="c-survey__token-button"
                :class="{ 'c-survey__token-button--disabled': isRemoveButtonDisabled('sectionThreeTokens') }"
                @click="updateTokens('sectionThreeTokens', -1)"
                :style="{ backgroundColor: isRemoveButtonDisabled('sectionThreeTokens') ? '#bcbec0' : sections.sectionThree.sectionColour }"
              >
                <div class="c-survey__icon c-survey__icon--minus"></div>
              </div>
              <h1 class="c-survey__token-allocation-count white-text">{{ submissionData.sectionThreeTokens }}</h1>
              <div
                class="c-survey__token-button"
                @click="updateTokens('sectionThreeTokens', 1)"
                :class="{ 'c-survey__token-button--disabled': isAddButtonDisabled }"
                :style="{ backgroundColor: isAddButtonDisabled ? '#bcbec0' : sections.sectionThree.sectionColour }"
              >
                <div class="c-survey__icon c-survey__icon--plus"></div>
              </div>
            </div>
          </div>
          <div class="c-survey__token-buttons c-survey__token-buttons--desktop">
            <div
              class="c-survey__token-button"
              :class="{ 'c-survey__token-button--disabled': isRemoveButtonDisabled('sectionThreeTokens') }"
              @click="updateTokens('sectionThreeTokens', -1)"
              :style="{ backgroundColor: isRemoveButtonDisabled('sectionThreeTokens') ? '#bcbec0' : sections.sectionThree.sectionColour }"
            >
              <div class="c-survey__icon c-survey__icon--minus"></div>
            </div>
            <h1 class="c-survey__token-allocation-count white-text">{{ submissionData.sectionThreeTokens }}</h1>
            <div
              class="c-survey__token-button"
              @click="updateTokens('sectionThreeTokens', 1)"
              :class="{ 'c-survey__token-button--disabled': isAddButtonDisabled }"
              :style="{ backgroundColor: isAddButtonDisabled ? '#bcbec0' : sections.sectionThree.sectionColour }"
            >
              <div class="c-survey__icon c-survey__icon--plus"></div>
            </div>
          </div>
        </div>

        <div class="c-survey__page-three-animation--desktop">
          <lottie-vue-player :src="pageThree.animationFile" :player-controls="false" :loop="true" :autoplay="true"> </lottie-vue-player>
          <!-- <lottie-vue-player ref="lottiePlayer" :src="pageThree.animationFile" :player-controls="false" :loop="false" :autoplay="false"></lottie-vue-player> -->
        </div>
      </div>

      <div v-if="!isNextButtonActive" class="c-survey__action-message c-survey__action-message--right c-survey__action-message--white">
        {{ getRemainingTokens > 0 ? `Spend ${getRemainingTokens} more tokens to continue` : "Spend all tokens to continue" }}
      </div>

      <div class="c-survey__actionbutton-row c-survey__actionbutton-row--right">
        <ActionButton :title="pageThree.prevLabel" :buttonAction="'prev'" :arrowLeft="true" :muted="true"></ActionButton>
        <ActionButton :title="pageThree.nextLabel" :buttonAction="'next'" :disabled="!isNextButtonActive"></ActionButton>
      </div>

      <div class="c-survey__page-three-animation--mobile">
        <lottie-vue-player :src="pageThree.animationFile" :player-controls="false" :loop="true" :autoplay="true"> </lottie-vue-player>
        <!-- <lottie-vue-player ref="lottiePlayer" :src="pageThree.animationFile" :player-controls="false" :loop="false" :autoplay="false"></lottie-vue-player> -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import ActionButton from "../ActionButton.vue";

export default {
  // data() {
  //   return {
  //     lottiePlayer: null,
  //   };
  // },
  created() {},
  computed: {
    ...mapFields(["content.settings", "content.sections", "content.pages.pageThree", "submissionData"]),

    getRemainingTokens() {
      return this.settings.totalTokens - (this.submissionData.sectionOneTokens + this.submissionData.sectionTwoTokens + this.submissionData.sectionThreeTokens);
    },

    isAddButtonDisabled() {
      return this.getRemainingTokens === 0;
    },

    isNextButtonActive() {
      if (this.settings.useAllTokens) {
        return this.getRemainingTokens === 0;
      } else {
        return (
          this.getRemainingTokens >= 0 &&
          this.submissionData.sectionOneTokens + this.submissionData.sectionTwoTokens + this.submissionData.sectionThreeTokens >= this.settings.minimumAllocatedTokens
        );
      }
    },
  },
  // watch: {
  //   isNextButtonActive(newValue) {
  //     if (newValue) {
  //       this.lottiePlayer.playSegments([10800, 18780], true);
  //     }
  //   },
  // },
  components: { ActionButton },
  // mounted() {
  //   this.lottiePlayer = this.$refs.lottiePlayer.lottie;
  //   this.lottiePlayer.loop = true;
  //   this.lottiePlayer.playSegments([0, 10800], true);
  // },
  methods: {
    updateTokens(field, value) {
      if (this.submissionData[field] + value >= 0 && this.getRemainingTokens - value >= 0) {
        this.submissionData[field] += value;
      }
    },

    isRemoveButtonDisabled(sectionName) {
      return this.submissionData[sectionName] === 0;
    },
  },
};
</script>
